import { render, staticRenderFns } from "./RiskAnalysisForm.vue?vue&type=template&id=3fa85bc6&"
import script from "./RiskAnalysisForm.vue?vue&type=script&lang=js&"
export * from "./RiskAnalysisForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RiskAnalysisForm.vue"
export default component.exports